(() => {
  const s = document.querySelector('.ih');
  if (!s || s.dataset.ready) return;
  s.dataset.ready = '1';
  const LABEL = { 'ifta-dynasty': 0, 'ifta-legacy': 1, 'ifta-gravity': 2, 'ifta-midnight': 3 };
  const hexRgb = (h) => { h = (h || '#b39a6b').replace('#', ''); return [0, 2, 4].map((i) => parseInt(h.substr(i, 2), 16) / 255); };
  const j = s.querySelector('.ih-j'), stage = s.querySelector('.ih-j__stage'), track = s.querySelector('.ih-j__track');
  const panels = [...track.children], P = panels.length;
  const bar = s.querySelector('.ih-j__bar i'), qnav = s.querySelector('.ih-q'), qbtns = [...s.querySelectorAll('.ih-q__btn')];
  const SC = (() => { const pw = s.closest('.page-wrapper'); return pw && /auto|scroll/.test(getComputedStyle(pw).overflowY) ? pw : null; })();
  const SCT = SC || window;
  const sy = () => (SC ? SC.scrollTop : window.scrollY);
  const vh = () => (SC ? SC.clientHeight : window.innerHeight);
  const docTop = (el) => el.getBoundingClientRect().top - (SC ? SC.getBoundingClientRect().top : 0) + sy();
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const panelLen = (+s.dataset.panel || 70) / 100;
  const clamp = (x, a, b) => Math.max(a, Math.min(b, x));
  const ease = (t) => (t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const lerp = (a, b, t) => a + (b - a) * t;
  const sm = (t) => t * t * (3 - 2 * t);

  // product photo and box photo take turns on every card
  const photos = [...s.querySelectorAll('.ih-photo.has-b')];
  if (photos.length && !calm) {
    let shopOn = false, tick = 0;
    const grid = s.querySelector('.ih-grid');
    if (grid) new IntersectionObserver((en) => { shopOn = en[0].isIntersecting; }, { rootMargin: '120px 0px' }).observe(grid);
    setInterval(() => {
      if (!shopOn || document.hidden) return;
      tick++;
      photos.forEach((ph, i) => setTimeout(() => { if (!ph.matches(':hover')) ph.classList.toggle('is-b', tick % 2 === 1); }, i * 380));
    }, 3400);
  }

  const handles = [...s.querySelectorAll('.ih-slot--card')].map((el) => el.dataset.b);
  const slot = (h, role) => s.querySelector('.ih-slot[data-b="' + h + '"][data-role="' + role + '"]');
  const bottles = handles.map((h, i) => ({
    h, i, label: LABEL[h] != null ? LABEL[h] : i,
    accent: hexRgb(getComputedStyle(slot(h, 'card').closest('.ih-card')).getPropertyValue('--acc').trim()),
    hero: slot(h, 'hero'), card: slot(h, 'card'), queue: slot(h, 'queue'), panel: slot(h, 'panel'),
    hover: 0, hoverT: 0, phase: i * 1.7
  }));
  bottles.forEach((b) => {
    const c = b.card.closest('.ih-card');
    c.addEventListener('pointerenter', (ev) => { if (ev.pointerType === 'mouse') b.hoverT = 1; });
    c.addEventListener('pointerleave', () => (b.hoverT = 0));
  });

  let jTop = 0, jLen = 1, heroToCard = 1, W = 0, lastIdx = -1, snapT = 0, geoVer = 0;
  function layout() {
    const V = vh();
    jLen = (P - 1) * V * panelLen;
    const hh = (jLen + V) + 'px';
    if (j.style.height !== hh) j.style.height = hh;
    jTop = docTop(j);
    W = stage.clientWidth;
    const c0 = bottles[0] && bottles[0].card;
    heroToCard = c0 ? Math.max(1, docTop(c0) + c0.offsetHeight / 2 - V * 0.52) : 1;
    if (gl) gl.resize(innerWidth, innerHeight, Math.min(devicePixelRatio || 1, innerWidth < 900 ? 1.5 : 1.75));
    geoVer++;
  }
  // raw scroll progress through the journey, 0..P-1
  function journeyX() { return clamp((sy() - jTop) / jLen, 0, 1) * (P - 1); }
  // each attar rests for a while before the next one slides in
  function rest(x) {
    const i = Math.floor(x);
    if (i >= P - 1) return P - 1;
    const f = x - i;
    return i + (f < .16 ? 0 : f > .84 ? 1 : ease((f - .16) / .68));
  }
  function scrollToPanel(i, smooth) {
    SCT.scrollTo({ top: jTop + (i / (P - 1)) * jLen + 2, behavior: smooth && !calm ? 'smooth' : 'auto' });
  }
  function scrollToShop() {
    const shop = s.querySelector('#shop');
    SCT.scrollTo({ top: docTop(shop) - 10, behavior: calm ? 'auto' : 'smooth' });
  }
  // only nudges when the user stopped halfway between two attars
  let touching = false;
  function snap() {
    if (touching) return;
    const y = sy();
    if (y <= jTop + 4 || y >= jTop + jLen - 4) return;
    const x = journeyX(), i = Math.floor(x), f = x - i;
    if (f > .16 && f < .84) scrollToPanel(f < .5 ? i : i + 1, true);
  }
  s.addEventListener('click', (e) => {
    const g = e.target.closest('[data-go]');
    if (!g) return;
    e.preventDefault();
    if (g.dataset.go === 'shop') scrollToShop(); else scrollToPanel(+g.dataset.go, true);
  });

  let jrTop = 0;
  function applyTrack(x, jr) {
    track.style.transform = 'translate3d(' + (-x * W).toFixed(2) + 'px,0,0)';
    const p = (x / (P - 1));
    if (bar) bar.style.width = (p * 100).toFixed(2) + '%';
    if (qnav) qnav.style.setProperty('--jp', p.toFixed(4));
    const idx = Math.round(x);
    if (idx !== lastIdx) {
      lastIdx = idx;
      panels.forEach((pn, i) => pn.toggleAttribute('inert', i !== idx));
      qbtns.forEach((q, i) => { q.classList.toggle('is-on', i === idx); q.classList.toggle('is-past', i < idx); });
    }
    jrTop = jr.top;
    const V = vh();
    s.classList.toggle('in-j', jr.top < V * 0.35 && jr.bottom > V * 0.65);
  }

  const cv = s.querySelector('.ih-gl');
  let gl = null, raf = 0, visible = true, t0 = performance.now();
  const mobile = () => innerWidth < 900;
  // geometry cache: DOM rects are re-read only when scroll, layout or the track moved
  const geo = new Map();
  const probe = bottles[0] ? bottles[0].card : j;
  let geoKey = '', lastDraw = 0, lastMove = 0, lastNow = 0, xd = -1, ed = -1;
  function rectOf(el) {
    let g = geo.get(el);
    if (!g) {
      const r = el.getBoundingClientRect();
      g = { cx: r.left + r.width / 2, cy: r.top + r.height / 2, h: r.height * 0.96 };
      geo.set(el, g);
    }
    return { cx: g.cx, cy: g.cy, h: g.h };
  }
  function mix(a, b, t) { return { cx: lerp(a.cx, b.cx, t), cy: lerp(a.cy, b.cy, t), h: lerp(a.h, b.h, t) }; }
  function frame(now) {
    raf = 0;
    if (!visible) return;
    const dt = Math.min(0.05, Math.max(0.001, (now - (lastNow || now - 16)) / 1000));
    lastNow = now;
    const V = vh(), y = sy();
    const jr = j.getBoundingClientRect();
    // targets follow the scroll; the shown values glide to them so touch jitter never shows
    const xt = rest(journeyX()), et = ease(clamp(1 - jr.top / V, 0, 1));
    if (xd < 0) { xd = xt; ed = et; }
    xd += (xt - xd) * (1 - Math.exp(-dt * 9));
    ed += (et - ed) * (1 - Math.exp(-dt * 11));
    if (Math.abs(xt - xd) < 0.0004) xd = xt;
    if (Math.abs(et - ed) < 0.0004) ed = et;
    const settling = xd !== xt || ed !== et;
    // phones: 30fps while idle, full rate while anything moves
    if (gl && !settling && mobile() && now - lastMove > 500 && now - lastDraw < 30) { raf = requestAnimationFrame(frame); return; }
    lastDraw = now;
    const key = y + '|' + jr.top.toFixed(1) + '|' + probe.getBoundingClientRect().top.toFixed(1) + '|' + xd.toFixed(4) + '|' + W + '|' + V + '|' + geoVer;
    if (key !== geoKey) {
      geoKey = key; lastMove = now; geo.clear();
      applyTrack(xd, jr);
    }
    if (!gl) { if (settling) raf = requestAnimationFrame(frame); return; }
    const x = xd, e = ed, time = (now - t0) / 1000;
    if (bottles.some((b) => Math.abs(b.hover - b.hoverT) > 0.004)) geo.clear();
    gl.begin();
    for (const b of bottles) {
      b.hover = lerp(b.hover, b.hoverT, 0.12);
      const card = rectOf(b.card);
      let pos = card, spin = Math.sin(time * 0.5 + b.phase) * 0.4 + b.hover * 0.7, roll = 0, tilt = 0.06;
      if (b.hero) {
        const t = clamp(y / heroToCard, 0, 1), k = ease(t);
        const hero = rectOf(b.hero);
        hero.cy += Math.sin(time * 1.1) * 6 * (1 - k);
        pos = mix(hero, card, k);
        spin = lerp(Math.sin(time * 0.45) * 0.5, spin, k) + sm(k) * Math.PI * 2;
        roll = Math.sin(k * Math.PI) * 0.3;
        tilt = lerp(0.1, 0.06, k);
      }
      if (e > 0.0005) {
        const q = rectOf(b.queue), pn = rectOf(b.panel);
        const seg = clamp(x - (b.i - 1), 0, 1), ks = ease(seg);
        const tgt = b.i === 0 ? pn : mix(q, pn, ks);
        const tspin = Math.sin(time * 0.5 + b.phase) * 0.35 + (b.i === 0 ? Math.PI * 2 : sm(ks) * Math.PI * 2);
        const troll = b.i === 0 ? 0 : Math.sin(ks * Math.PI) * 0.3;
        if (seg >= 1) tgt.cy += Math.sin(time * 1.2 + b.phase) * 4;
        pos = mix(pos, tgt, e);
        spin = lerp(spin, tspin, e) + sm(e) * Math.PI * 2;
        roll = lerp(roll, troll, e) + Math.sin(e * Math.PI) * 0.2;
      }
      if (pos.cy + pos.h < -50 || pos.cy - pos.h > V + 50 || pos.cx < -pos.h || pos.cx > innerWidth + pos.h) continue;
      gl.draw({ label: b.label, cx: pos.cx, cy: pos.cy, h: pos.h, spin, roll, tilt, fade: 1, accent: b.accent, glow: pos.h > 300 ? 0.32 : pos.h > 150 ? 0.18 : 0 });
    }
    raf = requestAnimationFrame(frame);
  }
  function kick() { if (!raf && visible) raf = requestAnimationFrame(frame); }
  function onScroll() {
    kick();
    clearTimeout(snapT); snapT = setTimeout(snap, 240);
  }
  if (calm) {
    s.classList.add('is-static');
    return;
  }
  layout();
  kick();
  SCT.addEventListener('scroll', onScroll, { passive: true });
  SCT.addEventListener('touchstart', () => { touching = true; clearTimeout(snapT); }, { passive: true });
  const untouch = () => { touching = false; clearTimeout(snapT); snapT = setTimeout(snap, 320); };
  SCT.addEventListener('touchend', untouch, { passive: true });
  SCT.addEventListener('touchcancel', untouch, { passive: true });
  let rT = 0;
  addEventListener('resize', () => { clearTimeout(rT); rT = setTimeout(() => { layout(); kick(); }, 150); });
  let roT = 0;
  new ResizeObserver(() => { clearTimeout(roT); roT = setTimeout(() => { layout(); kick(); }, 80); }).observe(s);
  new IntersectionObserver((en) => { visible = en[0].isIntersecting; if (visible) kick(); }).observe(s);
  document.addEventListener('visibilitychange', () => { visible = !document.hidden; if (visible) { lastNow = 0; kick(); } });
  function startGL() {
    if (gl || !window.IftaGL) return;
    try {
      gl = IftaGL.create(cv, { segments: innerWidth < 900 ? 64 : 96, onReady: () => { s.classList.add('gl-on'); kick(); } });
    } catch (err) { gl = null; }
    if (!gl) return;
    layout();
    kick();
    cv.addEventListener('webglcontextlost', (ev) => { ev.preventDefault(); s.classList.remove('gl-on'); gl = null; });
  }
  addEventListener('load', () => { layout(); kick(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { layout(); kick(); });
  if (window.IftaGL) startGL(); else addEventListener('load', startGL, { once: true });
  // desktop card tilt, batched to one write per frame
  s.querySelectorAll('[data-tilt]').forEach((c) => {
    let pend = 0, tx = '';
    c.addEventListener('pointermove', (ev) => {
      if (ev.pointerType !== 'mouse') return;
      const r = c.getBoundingClientRect(), px = (ev.clientX - r.left) / r.width - 0.5, py = (ev.clientY - r.top) / r.height - 0.5;
      tx = 'perspective(900px) rotateX(' + (-py * 4).toFixed(2) + 'deg) rotateY(' + (px * 5).toFixed(2) + 'deg) translateY(-3px)';
      if (!pend) pend = requestAnimationFrame(() => { pend = 0; c.style.transform = tx; });
    });
    c.addEventListener('pointerleave', () => { if (pend) { cancelAnimationFrame(pend); pend = 0; } c.style.transform = ''; });
  });
})();